import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  Amount,
  IntoMoney,
  NameSupplies,
  Notes,
  Plan,
  SMALL_ITEM_SIZE,
  Unit,
  UnitPrice,
} from "./_fields";

type RepairToolTemplate = {
  NameSupplies: string;
  Amount: number;
  Unit: string;
  UnitPrice: number;
  IntoMoney: number;
  Plan: string;
  Notes: string;
};

export const repairToolTemplate: TemplatesValue<RepairToolTemplate> = {
  fileName: "DanhSachPhuongAnSuaChuaDeXuat",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    {
      ...NameSupplies,
      header: "Tên vật tư",
    },
    Amount,
    {
      ...Unit,
      header: "Đơn vị tính",
      itemSize: SMALL_ITEM_SIZE,
    },
    UnitPrice,
    IntoMoney,
    Plan,
    Notes,
  ],
  fields: ["NameSupplies", "Amount", "Unit", "UnitPrice", "IntoMoney", "Plan", "Notes"],
};
